import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {
    whiteSpace: 'pre-wrap',
  },
  clickable: {
    cursor: 'pointer',
  },
  underline: {
    textDecoration: 'underline',
  },
});

function AdvancedTypography({
  className,
  classes,
  component,
  fragments,
  ...rest
}) {
  const Component = component;

  return (
    <Component
      className={classNames(classes.root, className)}
      {...rest}
    >
      {fragments.map(({
        bold,
        underline,
        className: fragmentClassName,
        color = 'primaryGray',
        variant = 'h6',
        onClick,
        text,
        weight,
        innerComponent = 'span',
        innerComponentProps = {},
      }, i) => (
        <Typography
          className={classNames(classes.text, fragmentClassName, {
            [classes.bold]: bold,
            [classes.underline]: underline,
            [classes.clickable]: !!onClick,
          })}
          color={color}
          component={innerComponent || component}
          key={i} // eslint-disable-line react/no-array-index-key
          variant={variant}
          weight={weight}
          onClick={onClick}
          {...innerComponentProps}
        >
          {text}
        </Typography>
      ))}
    </Component>
  );
}

AdvancedTypography.defaultProps = {
  className: '',
  component: 'span',
};

AdvancedTypography.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  component: PropTypes.string,
};

export default withStyles(styles)(AdvancedTypography);
